var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "counter mg--b-4", class: _vm.classColumn }, [
    _c(
      "div",
      { staticClass: "container-literal" },
      [
        _vm.literal
          ? _c("p", { staticClass: "text-small blueDark mg mg--b-2" }, [
              _vm._v(_vm._s(_vm.literal))
            ])
          : _vm._e(),
        _vm.showTooltip
          ? _c("ma-tooltip", { attrs: { textInfo: _vm.textTooltip } })
          : _vm._e()
      ],
      1
    ),
    _c("div", { staticClass: "input-and-buttons" }, [
      _c(
        "button",
        {
          staticClass: "mainBlue",
          class: _vm.isDisabledClass,
          style: _vm.buttonFullSize,
          on: { click: _vm.handleSustract }
        },
        [
          _c("svgicon", {
            attrs: {
              icon: "ico-moins",
              height: "16",
              width: "16",
              color: "#FFFFFF"
            }
          })
        ],
        1
      ),
      _c("input", {
        style: _vm.inputFullSize,
        attrs: { type: "text", name: _vm.name },
        domProps: { value: _vm.value },
        on: { input: $event => _vm.handleUpdateInput($event.target.value) }
      }),
      _c(
        "button",
        {
          staticClass: "mainBlue",
          style: _vm.buttonFullSize,
          on: { click: _vm.handleAdd }
        },
        [
          _c("svgicon", {
            attrs: {
              icon: "ico-plus",
              height: "16",
              width: "16",
              color: "#FFFFFF"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }